import CryptoJS from 'crypto-js'
export const isDigit = text => /^\d+$/.test(text)
export const replcePhoneWithAsterik = text => {
  if (isDigit(text)) {
    return text.replace(/\d(?=\d{3})/g, '*')
  } else {
    return text
  }
}

export const compare = (obj1, obj2) => {
  if (obj1.rank < obj2.rank) {
    return -1
  }
  if (obj1.rank > obj2.rank) {
    return 1
  }
  return 0
}

export const parsoDi = obj =>
  CryptoJS.AES.encrypt(JSON.stringify(obj), 'tohse na ho payi').toString()

export const aajDi = obj => {
  let wordArray = CryptoJS.lib.WordArray.create(obj)
  let EncodedBase64 = wordArray.toString(CryptoJS.enc.Base64)
  let decodedString = atob(EncodedBase64)
  let bytes = CryptoJS.AES.decrypt(decodedString.toString(), 'tohse na ho payi')
  let decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  return decryptedData
}

export const initAgora = (streamList, displayMode) => {
  let $ = this
  // rerendering
  let canvas = document.querySelector('#ag-canvas')
  // pip mode (can only use when less than 4 people in channel)
  if (displayMode === 'pip') {
    let no = streamList.length
    if (no > 4) {
      $.displayMode = 'tile'
      return
    }

    streamList.map((item, index) => {
      let id = item.getId()
      let dom = document.querySelector('#ag-item-' + id)
      if (!dom) {
        dom = document.createElement('section')
        dom.setAttribute('id', 'ag-item-' + id)
        dom.setAttribute('class', 'ag-item')
        canvas.appendChild(dom)
        item.play('ag-item-' + id)
      }
      if (index === no - 1) {
        dom.setAttribute('style', `grid-area: span 12/span 24/13/25`)
      } else {
        dom.setAttribute(
          'style',
          `grid-area: span 3/span 4/${4 + 3 * index}/25;
          z-index:1;width:calc(100% - 20px);height:calc(100% - 20px);display:none`
        )
      }
      item.player.resize && item.player.resize()
    })
  } else if (displayMode === 'tile') {
    // tile mode
    let no = streamList.length
    streamList.map((item, index) => {
      let id = item.getId()
      let dom = document.querySelector('#ag-item-' + id)
      if (!dom) {
        dom = document.createElement('section')
        dom.setAttribute('id', 'ag-item-' + id)
        dom.setAttribute('class', 'ag-item')
        canvas.appendChild(dom)
        item.play('ag-item-' + id)
      }
      dom.setAttribute('style', `grid-area: ${tile_canvas[no][index]}`)
      if (item.player) item.player.resize && item.player.resize()
    })
  } else if (displayMode === 'share') {
    // screen share mode (tbd)
  }
}

export const mappedMCashImages = value => {
  var imgObj = {
    2: 'https://d19d4vszpb8ku9.cloudfront.net/1848c9cc-3429-4c26-bbbf-2d787d2664c4.png',
    5: 'https://d19d4vszpb8ku9.cloudfront.net/23c25f69-722e-46ea-8e1b-9ab599f5419d.png',
    10: 'https://d19d4vszpb8ku9.cloudfront.net/ac761b31-8b4b-4f0a-9b92-85c980e5f886.png',
    15: 'https://d19d4vszpb8ku9.cloudfront.net/a2e00573-3336-4dc9-96b5-033779cfbbf1.png',
    20: 'https://d19d4vszpb8ku9.cloudfront.net/5d8b7b64-ef08-4f96-9cf1-9221592650f4.png',
    50: 'https://d3ojr524tgla9b.cloudfront.net/8a6b3b08-3101-427b-a5b5-4f0773f3c29b.png',
    100: 'https://d3ojr524tgla9b.cloudfront.net/a30b67d9-dd95-4211-9601-fd1bc884b714.png'
  }
  return imgObj[value]
}

export const mappedWalletImages = value => {
  var imgObj = {
    2: 'https://d2lfz79baq3ns3.cloudfront.net/9768a42f-0b4d-46c2-8d2c-82a55c99eb43.png',
    5: 'https://d2lfz79baq3ns3.cloudfront.net/398a4413-d928-4904-b1c6-a5a40da506a5.png',
    10: 'https://d2lfz79baq3ns3.cloudfront.net/ef121517-920e-4205-a945-e8041708c94a.png',
    15: 'https://d2lfz79baq3ns3.cloudfront.net/9ea98d1d-192f-4ae0-8833-1217ed6050e2.png',
    20: 'https://d2lfz79baq3ns3.cloudfront.net/dcfb3924-7c4c-418e-bc39-91d172d885b0.png'
  }
  return imgObj[value]
}

export const ConvertSecondsTohours = seconds => {
  const format = val => `0${Math.floor(val)}`.slice(-2)
  const hours = seconds / 3600
  const minutes = (seconds % 3600) / 60
  return [hours, minutes, seconds % 60].map(format).join(':')
}

export const Timer = date => {
  var deadline = new Date(date).getTime()
  var now = new Date().getTime()
  var t = deadline - now
  var mili = t
  if (mili > 0) {
    mili = t
  } else {
    mili = 0
  }
  return ConvertSecondsToDays(mili)
}

export const ConvertSecondsToDays = milisecond => {
  var resObj = {}
  if (milisecond === 0) {
    const format = val => `0${Math.floor(val)}`.slice(-2)
    const Days = milisecond / (1000 * 60 * 60 * 24)
    const hours = (milisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    const minutes = (milisecond % (1000 * 60 * 60)) / (1000 * 60)
    const seconds = (milisecond % (1000 * 60)) / 1000

    const opts = ['Days', 'Hours', 'Minutes', 'Seconds']
    let red = (a, b, i) => {
      a[opts[i]] = b
      console.log(a, b, i)
      return a
    }
    let res = [Days, hours, minutes, seconds % 60].map(format).reduce(red, {})
    resObj.response = res
    resObj.off = true
  } else {
    const format = val => `0${Math.floor(val)}`.slice(-2)
    const Days = milisecond / (1000 * 60 * 60 * 24)
    const hours = (milisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    const minutes = (milisecond % (1000 * 60 * 60)) / (1000 * 60)
    const seconds = (milisecond % (1000 * 60)) / 1000

    const opts = ['Days', 'Hours', 'Minutes', 'Seconds']
    let red = (a, b, i) => {
      a[opts[i]] = b
      console.log(a, b, i)
      return a
    }
    let res = [Days, hours, minutes, seconds % 60].map(format).reduce(red, {})
    resObj.response = res
    resObj.off = false
  }

  return resObj
}
